(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    import('@theme/component').then(({ Component }) => {
  class KaratasServiceTabs extends Component {
    selectTab(event) {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab && this.contains(tab)) this.activateTab(tab, false);
    }
    handleKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const current = tabs.indexOf(event.target);
      if (current < 0) return;
      event.preventDefault();
      const rtl = getComputedStyle(this).direction === 'rtl';
      let next = current;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else {
        const step = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
        next = (current + step + tabs.length) % tabs.length;
      }
      this.activateTab(tabs[next], true);
    }
    activateTab(target, moveFocus) {
      for (const tab of this.querySelectorAll('[role="tab"]')) {
        const selected = tab === target;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panelId = tab.getAttribute('aria-controls');
        const panel = panelId ? this.querySelector('#' + CSS.escape(panelId)) : null;
        if (panel instanceof HTMLElement) panel.hidden = !selected;
      }
      if (moveFocus) target.focus();
    }
  }
  if (!customElements.get('karatas-service-tabs')) customElements.define('karatas-service-tabs', KaratasServiceTabs);
  });
  } catch(e) { console.error(e); }
})();

})();
